// extracted by mini-css-extract-plugin
module.exports = {"PageSubTitle":"PageSubTitle_PageSubTitle__6Nrkv"};